import { render, staticRenderFns } from "./TicketPriorityPicker.vue?vue&type=template&id=335a222d&scoped=true"
import script from "./TicketPriorityPicker.vue?vue&type=script&lang=js"
export * from "./TicketPriorityPicker.vue?vue&type=script&lang=js"
import style0 from "./TicketPriorityPicker.vue?vue&type=style&index=0&id=335a222d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a222d",
  null
  
)

export default component.exports